"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'width',
    'w',
    'maxWidth',
    'fontSize',
    'f',
    'color',
    'bg',
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'active',
    'ratio',
    'bold',
    'caps',
    'size',
    'left',
    'center',
    'right',
    'justify',
    'top',
    'bottom',
    'z',
    'backgroundImage',
    'borderWidth',
    'size',
    'position',
    'index',
    'direction',
    'text',
];
